<script setup lang="ts">
import { isDashboardPage, isMarketingPath } from "~/utils/isDashboardPage";
import { useShowAppMenu } from "~/composables/useShowAppMenu";

const AppPortalMenu = defineAsyncComponent(
  () => import("~/components/App/AppPortalMenu.vue"),
);

const route = useRoute();
const isMarketingShell = computed(() => isMarketingPath(route.path));
const isPortalShell = computed(() => isDashboardPage(route.path));
const { showAppMenu } = useShowAppMenu();
</script>

<template>
  <!--
    Portal: client-only shell inside ion-app, avoids auth hydration mismatch.
    Marketing: SSR via NuxtPage, deliberately outside ion-app. Ionic's ion-app
    custom element empties its own children when it upgrades, which starves
    Vue's hydration and makes it mount a second, duplicate copy of the page.
  -->
  <NuxtPage v-if="isMarketingShell" />
  <ion-app v-else suppress-hydration-warning>
    <ClientOnly v-if="isPortalShell">
      <ion-split-pane
        v-if="showAppMenu"
        content-id="main-content"
        when="lg"
      >
        <AppPortalMenu />
        <div id="main-content" class="portal-page-host">
          <NuxtPage />
        </div>
      </ion-split-pane>
      <div v-else id="main-content" class="portal-page-host">
        <NuxtPage />
      </div>
      <template #fallback>
        <div
          class="portal-page-host portal-page-host--boot"
          aria-hidden="true"
        />
      </template>
    </ClientOnly>
    <NuxtPage v-else />
  </ion-app>
</template>
